import gql from 'graphql-tag';

export const STOCK_TRANSFER_FRAGMENT = gql`
    fragment StockTransferFragment on StockTransfer {
        _id
        createdAt
        updatedAt
        transferDate
        destinationColumnId
        destinationColumn {
            _id
            name
            fullname
        }
        originColumnId
        originColumn {
            _id
            name
            fullname
        }
        products {
            productId
            fullname
            conditionning
            packagesPerBatch
            originStockAvailable
            destinationStockAvailable
            quantity
        }
        deliveryId
        delivery {
            state
        }
        reassortmentFlow
        shouldUpdateStockImmediately
        state
        stateHistory {
            state
            createdAt
            createdBy
            createdByName
        }
    }
`;
